/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, total: NonNullable<unknown> }} Team_Manager_Licenses_UsedInputs */

const en_team_manager_licenses_used = /** @type {(inputs: Team_Manager_Licenses_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.total} licenses used`)
};

const fr_team_manager_licenses_used = /** @type {(inputs: Team_Manager_Licenses_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.total} licences utilisées`)
};

const de_team_manager_licenses_used = /** @type {(inputs: Team_Manager_Licenses_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verwendete ${i?.used} / ${i?.total} Lizenzen`)
};

const it_team_manager_licenses_used = /** @type {(inputs: Team_Manager_Licenses_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.total} licenze utilizzate`)
};

const ru_team_manager_licenses_used = /** @type {(inputs: Team_Manager_Licenses_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Используемые лицензии ${i?.used} / ${i?.total}`)
};

const es_team_manager_licenses_used = /** @type {(inputs: Team_Manager_Licenses_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.total} licencias utilizadas`)
};

const zh_cn2_team_manager_licenses_used = /** @type {(inputs: Team_Manager_Licenses_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已使用的 ${i?.used} / ${i?.total} 许可证`)
};

const ja_team_manager_licenses_used = /** @type {(inputs: Team_Manager_Licenses_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.total} ライセンス使用`)
};

const hi_team_manager_licenses_used = /** @type {(inputs: Team_Manager_Licenses_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.total} लाइसेंसों का उपयोग किया गया`)
};

const pt_pt2_team_manager_licenses_used = /** @type {(inputs: Team_Manager_Licenses_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Licenças ${i?.used} / ${i?.total} utilizadas`)
};

/**
* | output |
* | --- |
* | "{used} / {total} licenses used" |
*
* @param {Team_Manager_Licenses_UsedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_licenses_used = /** @type {((inputs: Team_Manager_Licenses_UsedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Licenses_UsedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_licenses_used(inputs)
	if (locale === "de") return de_team_manager_licenses_used(inputs)
	if (locale === "it") return it_team_manager_licenses_used(inputs)
	if (locale === "ru") return ru_team_manager_licenses_used(inputs)
	if (locale === "es") return es_team_manager_licenses_used(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_licenses_used(inputs)
	if (locale === "ja") return ja_team_manager_licenses_used(inputs)
	if (locale === "hi") return hi_team_manager_licenses_used(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_licenses_used(inputs)
	return en_team_manager_licenses_used(inputs)
});